<template>
    <div class="devices-list__block" v-if="deviceData">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block">
                <device-favorite :device="deviceData"></device-favorite>
                <div class="d-inline-flex" v-if="deviceData.state != null">
                    <v-switch
                        v-model="deviceState"
                        inset
                        dense
                        hide-details
                        class="pa-0"
                        @click="changeDeviceSwitch"
                        :loading="loading"
                        color="#FF8484"
                        :disabled="deviceData.is_action || deviceData.disabled"
                    ></v-switch>
                </div>
            </v-flex>
        </v-layout>
        <div class="main-text mt-3" v-if="!deviceData.is_action">
<!--            <v-slider-->
<!--                v-model="deviceData.state.value"-->
<!--                :tick-labels="tickLabels"-->
<!--                ticks=""-->
<!--                min="18"-->
<!--                max="28"-->
<!--                class="warm-floor-slider"-->
<!--                dense-->
<!--                hide-details-->
<!--                @change="changeDeviceSlider"-->
<!--            >-->
<!--            </v-slider>-->

            <v-slider
                v-model="deviceData.state.value"
                min="0"
                max="100"
                class="dimmable-slider"
                thumb-label
                dense
                hide-details
                :readonly="loading || !readonly || deviceData.disabled"
                @change="changeDeviceSlider"
            >
                <template v-slot:prepend>
                    <span class="main-text">0%</span>
                </template>
                <template v-slot:append>
                    <span class="main-text">100%</span>
                </template>
            </v-slider>
        </div>
        <v-flex d-flex justify-end>
            <div v-if="deviceData.is_action && deviceData.state" class="note-row">
                {{deviceData.state.last_update.slice(0, 16)}}, &nbsp
            </div>
        </v-flex>
    </div>
</template>

<script>
import { LOADING_TIMEOUT } from "@/utils/constants.js";
export default {
    name: "WarmFloorDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: { state: null },
            deviceState: false,
            deviceStateOldValue: null,
            tickLabels: ['18', '', '20', '', '22', '', '24', '', '26', '', '28',],
            loading: false,
            scrollPrev: 0,
            scrollNext: 0,
            scrollTimeout: null,
            disabledTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state.value ? true : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.disabledTimeout) {
            clearTimeout(this.disabledTimeout);
        }
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    },
    computed: {
        isScrolled() {
            return this.$store.state.scrolled;
        },
        readonly() {
            return this.scrollPrev == this.scrollNext;
        },
    },
    watch: {
        device(val) {
            if (val) {
                this.deviceData = val;
                this.loading = false;
                this.deviceState = this.deviceData.state.value ? true : false;
                if (this.disabledTimeout) {
                    clearTimeout(this.disabledTimeout);
                    this.deviceData.disabled = false;
                }
            }
        },
        isScrolled(val) {
            this.scrollNext = val;
            this.checkScroll();
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        checkScroll() {
            if (this.scrollPrev != this.scrollNext) {
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = setTimeout(() => {
                    this.scrollPrev = this.scrollNext;
                }, 800);
            }
        },
        changeDeviceSwitch() {
            if (!this.deviceData.is_action) {
                if (this.deviceState) {
                    this.deviceData.state.value = 28;
                } else {
                    this.deviceData.state.value = 0;
                }
                this.changeDeviceValue();
            }
        },
        changeDeviceSlider() {
            if (!this.deviceData.is_action) {
                setTimeout(() => {
                    this.changeDeviceValue();
                }, 1000);
            }
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            if (this.disabledTimeout) {
                clearTimeout(this.disabledTimeout);
            }
            this.disabledTimeout = setTimeout(() => {
                this.deviceData.disabled = false;
                this.deviceData.state = this.deviceStateOldValue;
            }, LOADING_TIMEOUT);
            this.$http.put('/devices/guest/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value > 0 ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    if (this.disabledTimeout) {
                        clearTimeout(this.disabledTimeout);
                    }
                    this.deviceData.disabled = false;
                    this.deviceData.state = this.deviceStateOldValue;
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
}
</script>

<style lang="scss" scoped>
.warm-floor-slider.v-input__slider::v-deep {
    .v-slider.v-slider--horizontal {
        margin-top: 44px;

        .v-slider__track-container {
            height: 16px;
            border-radius: 30px;

            .v-slider__track-background.primary {
                border-radius: 30px;
                background-color: #F7F7F9 !important;
            }

            .v-slider__track-fill.primary {
                border-top-left-radius: 30px;
                border-bottom-left-radius: 30px;
                background-color: var(--rh-white-color) !important;
                background: var(--rh-linear-gradient);
            }
        }
    }

    .v-slider__thumb.primary {
        background-color: var(--rh-white-color) !important;
        background: var(--rh-linear-gradient);
        height: 28px;
        width: 28px;
        border: 3px solid var(--rh-white-color) !important;

        &::after,
        &::before {
            content: none;
        }

    }
    .v-slider__ticks-container .v-slider__tick {
        width: 0 !important;

        .v-slider__tick-label {
            top: -55px;
            transform: none;

            &::before {
                content: "";
                width: 4px;
                height: 0px;
                border: 1px solid var(--rh-subtitle-color);
                transform: rotate(90deg);
                position: absolute;
                top: 26px;
                left: 7px;
            }

            &::after {
                content: "°";
            }
        }

        &:last-child .v-slider__tick-label {
            transform: translateX(-50%);
        }
    }
}
</style>